module.exports = __webpack_public_path__ + "static/media/Income-Expense-Analysis.4b6ce28d.jpg";